export default "__VITE_ASSET__By6hZRQF__"